<template>
    <div id="app" v-cloak>
        <router-view></router-view>
        <el-backtop></el-backtop>
    </div>
</template>
<script>
export default {
    name:'Vue'
}
</script>
<style lang="less" scoped>
[v-cloak]{
    display: none;
}
</style>